import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../Services/Auth/auth.service';
import { BehaviorSubject, map } from 'rxjs';
import { FeatureFlag } from '../interfaces/feature-flags.interface';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  featureFlags = new BehaviorSubject<any>(null);
  featureFlags$ = this.featureFlags.asObservable();

  accessToken: string | undefined = '';
  constructor(private http: HttpClient, private userAuth: AuthService) {}

  headers = new HttpHeaders({
    'content-type': 'application/json',
    Authorization: `Bearer ${this.accessToken}`,
  });

  getFeatureFlag() {
    const httpUrl = environment.apiUrl + `/AppSettings/GetFeatureFlags`;
    const options = {
      headers: this.headers,
    };
    return this.http.get<FeatureFlag[]>(httpUrl, options).pipe(
      map((response) => {
        const flags: { [key: string]: boolean } = {};
        response.forEach((flag: FeatureFlag) => {
          flags[flag.key] = flag.value;
        });
        return flags;
      })
    );
  }
}
